import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import {
  type ErrorFileUploadResponse,
  isErrorFileUploadResponse,
} from '../service/file-upload-response';

@Pipe({
  name: 'isErrorFileUploadResponse',
})
export class IsErrorFileUploadResponsePipe implements PipeTransform {
  transform(value: unknown): value is ErrorFileUploadResponse {
    return isErrorFileUploadResponse(value);
  }
}
